/** Noop for browser compatibility */
export function setMaxListeners() { }
//# sourceMappingURL=events.browser.js.map